module.exports = __webpack_public_path__ + "static/media/goldenprize-mackerel-naturalChili.088ee7a3.png";